import React, { useState, useEffect, useCallback } from "react";
import { FaClockRotateLeft } from "react-icons/fa6";
import HistoryPopup from "./HistoryPopup";
import { useTranslation } from "../hooks/useTranslation";

const Header = ({ username = "Xxx Xxx" }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [headerLogo, setHeaderLogo] = useState(null);
  const { t } = useTranslation();

  // Logo yükleme helper
  const loadLogo = useCallback((src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(src);
      img.onerror = reject;
      img.src = src;
    });
  }, []);

  // Logo yükleme (fallback destekli)
  const loadLogoWithFallback = useCallback(async (paths) => {
    for (const path of paths) {
      try {
        const logoPath = await loadLogo(path);
        setHeaderLogo(logoPath);
        return;
      } catch {
        continue;
      }
    }
    setHeaderLogo(null);
  }, [loadLogo]);

  // Header logo'yu yükle
  useEffect(() => {
    loadLogoWithFallback(['/static/image/logo.webp', '/static/image/logo.png']);
  }, [loadLogoWithFallback]);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <>
      <div className="header-container">
        <div className="header-content">
          {headerLogo && (
            <div className="header-logo-container">
              <img 
                src={headerLogo}
                alt="Logo"
                className="header-logo"
              />
            </div>
          )}
          <h1 className="header-title" style={{ color: "var(--header-title-color)" }}>
            <div
              className="history-icon"
              onClick={openPopup}
              style={{
                color: "var(--header-icon-color)",
                backgroundColor: "var(--header-icon-bg-color)",
              }}
            >
              <FaClockRotateLeft size={24} />
            </div>
            <span className="welcome-text">{t('header.welcome', 'Hoşgeldin')}</span>{" "}
            <span className="username-text">{username},</span>
          </h1>
          <p
            className="header-subtitle"
            style={{ color: "var(--header-subtitle-color)" }}
          >
            {t('header.subtitle', 'Lütfen talep ettiğiniz bonusu seçiniz.')}
          </p>
        </div>
      </div>
      <HistoryPopup isOpen={isPopupOpen} onClose={closePopup} />
    </>
  );
};

export default Header;
